import * as User from '../../user'
export const TOGGLE_USER_MENU = 'TOGGLE_USER_MENU'
export const CLICK_OUTSIDE = 'CLICK_OUTSIDE'

export const NoUser: User.User = {
  account_name: '',
  email_address: '',
  first_name: '',
  last_name: '',
  roles: [],
}



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/constants.ts